module.exports = __webpack_public_path__ + "img/lexus.3c4fc913.png";